import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Badge, Card, CardBody } from "reactstrap";
import { baseURL, imageURL } from "../../../../Services/api/baseURL";
import axios from "axios";
import { toast } from "react-toastify";
import { Package } from "react-feather";

const TopBoughtProducts = ({ customerId }) => {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);

  const fetchTopBought = async () => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem("token"));

      const response = await axios.get(
        `${baseURL}/api/customers/get-topBought/${customerId}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );

      if (response.status === 200) {
        setProducts(response.data?.data?.topProducts || []);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch top bought products");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (customerId) fetchTopBought();
  }, [customerId]);
  

  const columns = [
 {
      name: "#",
      selector: (_, index) => index + 1,
      width: "80px",
      center: true,
      cell: (row, index) => (
        <div className="d-flex align-items-center justify-content-center">
          <Badge 
            color={index < 3 ? "success" : "light"} 
            pill 
            className={`fw-bold ${index < 3 ? "text-white" : "text-dark"}`}
          >
            {index + 1}
          </Badge>
        </div>
      ),
    },
    {
      name: "Product",
      selector: (row) => row.productName,
      cell: (row) => (
        <div className="d-flex align-items-center">
          {row.productImage ? (
            <img
              src={imageURL + row.productImage}
              alt={row.productName}
              style={{
                width: 40,
                height: 40,
                borderRadius: "6px",
                marginRight: "10px",
                objectFit: "cover",
              }}
            />
          ) : (
            <div
              className="d-flex align-items-center justify-content-center me-2"
              style={{
                width: 40,
                height: 40,
                background: "#f3f4f6",
                borderRadius: "6px",
              }}
            >
              <Package size={18} className="text-muted" />
            </div>
          )}
          <span>{row.productName}</span>
        </div>
      ),
      sortable: true,
      minWidth: "220px",
    },
    {
      name: "Category",
      selector: (row) => row.categoryName || "-",
      sortable: true,
      center: true,
      minWidth: "180px",
    },
    {
      name: "Sub Category",
      selector: (row) => row.subCategoryName || "-",
      sortable: true,
      center: true,
      minWidth: "200px",
    },
{
  name: "Total Units",
  selector: (row) => row.totalUnits,
  sortable: true,
  width: "150px",
  center: true,
  cell: (row) => <div className="text-center w-100">{row.totalUnits}</div>,
},
{
  name: "Total Orders",
  selector: (row) => row.totalOrders,
  sortable: true,
  width: "150px",
  center: true,
  cell: (row) => <div className="text-center w-100">{row.totalOrders}</div>,
},

  ];

  return (
    <Card className="shadow-sm border-0">
      <CardBody>
        <h5 className="mb-3 fw-bold">Top Bought Products</h5>

        {loading ? (
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="text-muted mt-2">Fetching products...</p>
          </div>
        ) : (
          <DataTable
            data={products}
            columns={columns}
            pagination
            highlightOnHover
            striped
            noDataComponent={
              <div className="text-center py-5">
                <div
                  className="rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                  style={{
                    width: "70px",
                    height: "70px",
                    backgroundColor: "#f8fafc",
                  }}
                >
                  <Package size={28} className="text-muted" />
                </div>
                <h6 className="text-muted mb-1">No top bought products</h6>
                <p className="text-muted small">
                  This customer hasn’t bought any products yet.
                </p>
              </div>
            }
            customStyles={{
              headRow: {
                style: {
                  backgroundColor: "#f8fafc",
                  borderBottom: "2px solid #e2e8f0",
                  fontWeight: "600",
                },
              },
              rows: {
                style: {
                  borderBottom: "1px solid #f1f5f9",
                  "&:hover": {
                    backgroundColor: "#f9fafb",
                  },
                },
              },
            }}
          />
        )}
      </CardBody>
    </Card>
  );
};

export default TopBoughtProducts;
